import { Chip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./styles";

export function ChipSla(value) {
  const theme = useTheme();
  const styles = useStyles(theme);

  if (value === 100) {
    return (
      <Chip
        size="small"
        sx={{
          ...styles.chipSla,
          backgroundColor: theme.palette.chip.main.completed,
        }}
        label={`${value}%`}
      />
    );
  }

  if (value < 100 && value >= 80) {
    return (
      <Chip
        size="small"
        sx={{
          ...styles.chipSla,
          backgroundColor: theme.palette.colors.yellow.darker,
        }}
        label={`${value}%`}
      />
    );
  }

  if (value < 80 && value >= 50) {
    return (
      <Chip
        size="small"
        sx={{
          ...styles.chipSla,
          backgroundColor: theme.palette.chip.main.inProgress,
        }}
        label={`${value}%`}
      />
    );
  }

  if (value < 50 && value >= 0 && value !== null) {
    return (
      <Chip
        size="small"
        sx={{
          ...styles.chipSla,
          backgroundColor: theme.palette.chip.main.waitingReturn,
        }}
        label={`${value}%`}
      />
    );
  }

  if (value < 0) {
    return (
      <Chip
        size="small"
        sx={{
          ...styles.chipSla,
          backgroundColor: theme.palette.chip.main.pending,
        }}
        label={`${value}%`}
      />
    );
  }

  return (
    <Typography
      sx={{
        ...styles.titleProtocolo,
        color:
          theme.palette.mode === "dark"
            ? theme.palette.primary.main
            : theme.palette.tertiary.main,
      }}
    >
      {value || ""}
    </Typography>
  );
}
